import React from "react";
import { Outlet } from "react-router-dom";
import AuthProvider from "../components/user/AuthProvider";
import DesktopProvider from "../components/DesktopProvider";

export default function AuthGuard({ fetchBalances = false, fetchProjects = false }) {
  return (
    <AuthProvider fetchBalances={fetchBalances} fetchProjects={fetchProjects}>
      <DesktopProvider>
        <Outlet />
      </DesktopProvider>
    </AuthProvider>
  );
}
